var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSubscriptionEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "75px",
    viewBox: "0 0 91.0 75.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,1364 L0,1364 L0,0 L1440,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-825.0 -479.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.0 150.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(307.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(291.0 330.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.0 0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.0676796,13.8785396 C77.3048112,13.8785396 74.1080757,16.9201167 74.1080757,20.9124554 C74.1080757,22.241801 74.4847882,23.3818546 75.0487928,24.3326163 L57.1794245,42.7735215 C52.2906752,34.788844 49.0939397,23.0032708 47.3997976,15.2078852 C50.0325285,13.8785396 51.9139627,11.2176975 51.9139627,7.98467749 C51.9139627,3.6137549 48.3405147,0 44.0136417,0 C39.688897,0 36.1133207,3.6137549 36.1133207,7.98467749 C36.1133207,11.2176975 37.9947549,13.8785396 40.6274858,15.2078852 C38.935472,23.0032708 35.7366082,34.788844 30.8457306,42.7735215 L12.9784907,24.3326163 C13.5424953,23.3818546 13.9192078,22.241801 13.9192078,20.9124554 C13.9192078,17.1094086 10.9097644,13.8785396 6.95960389,13.8785396 C3.00944339,13.8785396 0,16.9201167 0,20.9124554 C0,24.7133512 3.00944339,27.9463712 6.95960389,27.9463712 L19.7486742,71.6685034 C19.9380946,72.4299732 20.6915196,73 21.6301084,73 L66.5844672,73 C67.3378922,73 68.0891889,72.4299732 68.4659014,71.6685034 L81.0676796,27.7549282 C84.830548,27.7549282 88.0294118,24.7133512 88.0294118,20.7210125 C87.8399914,16.9201167 84.830548,13.8785396 81.0676796,13.8785396",
    stroke: "#666666",
    strokeWidth: 2,
    fill: "none",
    strokeMiterlimit: 10
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSubscriptionEmpty);
export default __webpack_public_path__ + "static/media/icSubscriptionEmpty.5139ca36f8123e5c88c3b2dbf7bfdfc1.svg";
export { ForwardRef as ReactComponent };